import { useDataContext } from 'context/DataStoreContext';
import { useApi } from 'model/Api';
import { User } from 'model/User';

export type AuthParams = { user: User };

export const getToken = () => localStorage.getItem('auth_token');

export const setToken = (token: string) => localStorage.setItem('auth_token', token);

export const resetToken = () => localStorage.removeItem('auth_token');

export const useAuth = () => {
  const api = useApi();
  const { state, dispatch } = useDataContext();
  const authState = state?.auth;

  return {
    ...(authState || {}),
    reference: async () => {
      if (authState?.user && getToken()) {
        return authState.user;
      }

      const authResultUser = await api.auth.reference();
      if (authResultUser) {
        dispatch?.({ type: 'SET_AUTH', payload: { user: authResultUser } });
      }

      return authResultUser;
    },
    login: async (email: string, password: string) => {
      const result = await api.auth.login(email, password);
      if (result) {
        setToken(result.token);
        dispatch?.({ type: 'SET_AUTH', payload: { user: result.user }});

        return { user: result.user };
      }

      return null;
    },
    logout: async () => {
      await api.auth.logout();
      resetToken();
      dispatch?.({ type: 'RESET_AUTH', payload: null });
    },
  };
};